import { MOSIDA_API_BASE_URL } from "../shop/mosidaApi";

const apiKey = String(process.env.REACT_APP_CREATIVE_API_KEY || "")
  .trim()
  .replace(/^['"]|['"]$/g, "");

function getHeaders() {
  const headers = {
    "Content-Type": "application/json",
  };
  if (apiKey) {
    headers["X-API-Key"] = apiKey;
  }
  return headers;
}

export async function getActivePinCode() {
  try {
    const response = await fetch(`${MOSIDA_API_BASE_URL}/admin/pin-code/public`, {
      method: "GET",
      headers: getHeaders(),
      cache: "no-store",
    });

    if (!response.ok) {
      const errorText = await response.text();
      return {
        success: false,
        error: `Failed to fetch PIN code: ${response.status} ${errorText}`,
      };
    }

    const data = await response.json();
    if (data && data.pinCode) {
      return { success: true, pinCode: String(data.pinCode) };
    }

    return { success: false, error: "Invalid response format from API" };
  } catch (error) {
    return {
      success: false,
      error: error?.message || "Network error while fetching PIN code",
    };
  }
}
